import { Layout } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChevronUp, LogoutIcon } from "../../asset";
import { Logo, LogoUser } from "../../asset/icons";
import { doPost } from "../../api/baseAPI";
import { checkValidationToken } from "../../util/errorHandler";
import {
  setIsCompletionAcc,
  setIsWaitingApprove,
  setToken,
} from "../../store/reducer/authentication.reducer";
import { ROUTES } from "../../constant/routeConstant";
import { useNavigate } from "react-router-dom";
import { GROLOG_BASE_URL } from "../../constant/apiConstant";
import LogoutModal from "../modal/LogoutModal";

export const Headbar = ({ props }) => {
  const [lang, setLang] = useState(false);
  const [logout, setLogout] = useState(false);
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);
  const { firstName } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const {isCompletion} = useSelector((state)=>state.page)
  const { token, setIsCompletionAcc } = useSelector((state) => state.auth);
  const navigate = useNavigate();
 // const { token } = useSelector((state) => state.auth);

  //   const state ={
  // show:false
  //   }

  //   const setShow =()=>{
  //     if(this.state.show){
  //       this.setState({show:false})
  //     }else{
  //       this.setState({show:false})
  //     }

  //   }

  // console.log("show", this.state.show);

  const doLogout = async () => {
    const url = `${GROLOG_BASE_URL}oauth/user/logout`;
    let result = { code: undefined, message: false };

    try {
      const response = await doPost(url, token, "");
      if (response) {
        dispatch(setToken());
        localStorage.removeItem("auth_code");
        localStorage.removeItem("request_id");
        navigate(ROUTES.INDEX);
      }
    } catch (error) {
      checkValidationToken(error, token, "", dispatch);
      if (error?.response?.status === 400) {
        result.code = error.response.status;
        result.message = error.response?.data?.payload?.message;
      }
    }
    return result;
  };

  const isCompletionLogout = ()=>{
    dispatch(setToken());
    localStorage.removeItem("auth_code");
    localStorage.removeItem("request_id");
    navigate(ROUTES.INDEX);
    console.log("sampe sini");
  }

  const backToPortal = () => {
    setIsLogoutOpen(false);
    navigate(ROUTES.SELECT_PORTAL);
  };

  return (
    <>
      <LogoutModal
        setIsLogoutOpen={setIsLogoutOpen}
        isOpen={isLogoutOpen}
        onBackToPortal={() => backToPortal()}
        onLogout={() => doLogout()}
        onLogoutCompletion={()=>isCompletionLogout()}
        title={"Logout"}
        description={"Are you sure want to Logout?"}
        primaryText={"Logout"}
        secondaryText={"Back To Portal"}
        iscompletion = {isCompletion}
      />
      <Layout.Header
        style={{
          backgroundColor: "white",
          display: "flex",
          justifyContent: "space-between",
          zIndex: 1,
          boxShadow: "0px 4px 12px -4px rgba(0, 0, 0, 0.15)",
          position: "sticky",
          top: 0,
        }}
        className="relative"
      >
        {/* {this.state.isLogout && (
          <ModalLogout
            key={RANDOM_ID(8)}
            modalOpen={this.state.isLogout}
            portal={() => this.portal()}
            logout={() => this.logout()}
            closeModal={() => this.closeModal()}
            onlyTrainingMaterial={this.props.isOnlyTrainingMaterial}
          />
        )} */}
        <div style={{ margin: "8px", paddingTop: "8px", marginLeft: "-22px" }}>
          <Logo />
        </div>
        <div style={{ display: "flex", cursor: 'pointer' }} onClick={() => setLogout(true)}>
          <div
            className="hidden"
            style={{ font: "normal normal 700 18px Roboto, sans-serif" }}
          >
            <div className="mt-6">EN</div>
            <img
              src={ChevronUp}
              alt="gg"
              className="w-4 ml-2 cursor-pointer"
              onClick={() => setLang(lang ? false : true)}
            />
          </div>

          <div
            style={{ margin: "24px", display: "flex", flexDirection: "column" }}
            // onClick={() => setLogout(true)}
          >
            <div
              className="flex"
              style={{ font: "normal normal 700 18px Roboto, sans-serif" }}
            >
              {firstName}
              {/* <img src={ChevronUp} alt="gg" className="w-4 ml-2 cursor-pointer" onClick={()=>setLogout(logout ? false : true)}/> */}
            </div>
            {logout ? (
              <>
                <div
                  className=" absolute bg-white-100 w-[216px] top-[64px] px-[14px] flex gap-[12px] cursor-pointer"
                  onClick={() => setIsLogoutOpen(true)}
                  onMouseLeave={() => setLogout(false)}
                >
                  <img src={LogoutIcon} />
                  <p className="font-[600] text-[18px]">Logout</p>
                </div>
              </>
            ) : (
              <></>
            )}
            {lang ? (
              <>
                <div className=" bg-white-100">ID</div>
              </>
            ) : (
              <></>
            )}

            <div style={{ marginTop: "-60px", textAlign: "right" }}>
              {/* {this.props.user_code ? this.props.user_code : "&nbsp"} */}
            </div>
          </div>
          <div style={{ margin: "20px 0 6px -6px" }}>
            {/* <User /> */}
            <LogoUser />
          </div>
        </div>
        {/* {this.getNotification()} */}
      </Layout.Header>
    </>
  );
};
export default Headbar;
